export default __webpack_public_path__ + "static/media/Man-working-in-office.13b0bcc6.png";